<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <h1 mat-dialog-title>Add A New User To Provider Account</h1>
  <div mat-dialog-content>
    <mat-form-field style="width: 49%; margin-right: 2%">
      <input placeholder="First Name" matInput formControlName="firstName" required />
    </mat-form-field>

    <mat-form-field style="width: 49%">
      <input placeholder="Last Name" matInput formControlName="lastName" required />
    </mat-form-field>

    <mat-form-field style="width: 100%">
      <input placeholder="Email Address" matInput formControlName="email" required />
    </mat-form-field>

    <mat-form-field style="width: 100%">
      <mat-label>Client</mat-label>
      <mat-select formControlName="client" required>
        <mat-option *ngFor="let client of clients" [value]="client">
          {{ client.client_name }}
        </mat-option>
      </mat-select>
      <mat-error>You must assign a client</mat-error>
    </mat-form-field>

    <!-- Admins only: Welby Clinical is cross-clinic (see canInviteWelbyClinical). -->
    <mat-checkbox *ngIf="canInviteWelbyClinical" formControlName="isWelbyClinical">Is Welby Clinical</mat-checkbox>

    <mat-form-field style="width: 100%; margin-top: 0.5rem" *ngIf="form.get('isWelbyClinical').value">
      <mat-label>Lead Nurse</mat-label>
      <mat-select formControlName="lead">
        <mat-option *ngFor="let lead of leads" [value]="lead"> {{ lead.lastName }}, {{ lead.firstName }} </mat-option>
      </mat-select>
      <mat-error>You must assign a lead</mat-error>
    </mat-form-field>
    <mat-form-field style="width: 100%; margin-top: 0.5rem" *ngIf="form.get('isWelbyClinical').value">
      <mat-label>Highest Licensure</mat-label>
      <mat-select formControlName="highest_licensure">
        <mat-option *ngFor="let licensure of highestLicensures" [value]="licensure">
          {{ licensure }}
        </mat-option>
      </mat-select>
      <mat-error>You must select a licensure</mat-error>
    </mat-form-field>
  </div>
  <div mat-dialog-actions>
    <button mat-button (click)="onNoClick()">Cancel</button>
    <button mat-raised-button color="primary" [disabled]="form.invalid" type="submit" cdkFocusInitial>
      Send Invite Email
    </button>
  </div>
</form>
